import { media } from 'styled-bootstrap-grid';
import styled from 'styled-components';

export const SubHeader = styled.div`
  padding: 1rem 1rem;
  display: flex;
  align-items: flex-start;

  ${media.md`
    padding: 1rem 0rem;
  `}
`;
